var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 125 215",
    width: 125,
    height: 215,
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h125v215H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M48.968 27.71L.758 0H0v.746l59.215 34.036v-.02l2.22 1.274v70.577L48.968 99.47 0 71.324v1.183l59.215 34.035v-.02l1.704.977-1.704.977v-.018L0 142.532v1.144l48.968-28.138 12.468-7.153v70.577l-2.22 1.275v-.02L0 214.254V215h.758l48.2-27.703 12.98-7.447L123.215 215H125v-72.468l-.48.276L62.978 107.5l61.51-35.288.513.295V0h-1.785L61.948 35.15l-12.98-7.44zm13.493 80.674v70.577l61.514 35.292v-70.578l-61.514-35.29zm0-1.77l61.514-35.29V.746L62.46 36.038v70.577z",
    fill: "#e8e8e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg-pattern.fa88a4e5be38fcc54cf3100511e1d17e.svg";
export { ForwardRef as ReactComponent };